module.exports = __webpack_public_path__ + "img/horizontal_6_4_3009.b853e300.png";